<template>
    <div class="px-4 py-5">

        <!-- <rfx-response-transitions
            v-if="$currentUserInfo.tenant_subdomain === 'sub2'"
            :response-id="responseId"
        >
            <template #default="{ transitions, startTransition }">
                <b-dropdown text="Transitions" variant="primary" class="">
                    <b-dropdown-item
                        v-for="trans in transitions"
                        :key="trans.trigger"
                        @click="startTransition(trans)"
                    >
                        {{ trans.label }} - {{ trans.description }}
                    </b-dropdown-item>
                </b-dropdown>
                
                <b-link
                    v-for="trans in transitions"
                    :key="trans.trigger"
                    @click="startTransition(trans)"
                >
                    <b-icon :icon="trans.icon" :variant="trans.color_variant"></b-icon>
                    {{ trans.label }} - {{ trans.description }}
                </b-link>
            </template>
        </rfx-response-transitions> -->

        <transition name="fade-fast">
            <div 
                v-if="!submitComplete"
                key="topText"
            >
                <h4>Review & Submit Response</h4>
                <p>Please ensure you have provided valid and correct information.</p>
            </div>
        </transition>

        <div class="d-flex flex-column align-items-center">
            <div class="w-100 max-width-700">

                <transition name="fade" mode="out-in">
                    
                    <busy-spinner
                        v-if="displayMode === 'checking'"
                        key="checking"
                        inner-class="my-5"
                        text="Checking if everything is ready to submit..."
                    ></busy-spinner>

                    <div
                        v-if="displayMode === 'checkedValid' || displayMode === 'checkedInvalid'"
                        key="checked"
                        class="mb-3 d-flex flex-column"
                    >

                        <div class="my-4 d-flex justify-content-center">
                            <!-- If server-side blocked - show those messages -->
                            <div v-if="displayMode === 'checkedInvalid'" key="checkedInvalidMessage" class="d-flex justify-content-center align-items-center">
                                <b-icon
                                    icon="x-circle-fill"
                                    variant="danger"
                                    font-scale="1.5"
                                    class="mr-3"
                                ></b-icon>
                                <div>
                                    <h5 class="text-muted mb-0">Unable to submit a response at this time.</h5> 
                                    <div>
                                        <p v-for="msg in checkInvalidMessages" :key="msg" class="mt-1 mb-0">
                                            {{ msg }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- If server-side OK, show local messages -->
                            <div v-if="displayMode === 'checkedValid'" key="checkedValidMessage" class="d-flex justify-content-center align-items-center">
                                <b-icon
                                    :icon="canSubmit ? 'check-circle-fill' : 'x-circle-fill'"
                                    :variant="canSubmit ? 'success' : 'danger'"
                                    font-scale="1.5"
                                    class="mr-3"
                                ></b-icon>
                                <div class="">
                                    <h5 class="text-muted mb-0">
                                        {{ canSubmit ? 'Ready to Submit' : 'Unable to Submit' }}
                                    </h5>
                                    <p v-if="canSubmit" class="mt-1 mb-0">Submitting {{ replySubmitCount }} new item{{ replySubmitCount > 1 ? 's' : '' }}</p>
                                    <p v-if="!hasRepliesToSubmit" class="mt-1 mb-0">You have not selected anything to submit</p>
                                </div>
                            </div>
                        </div>

                        <div>  <!-- List of things being submitted -->
                            <!-- <h5>What you are submitting:</h5> -->
                            <b-list-group>
                                <b-list-group-item
                                    v-for="todo in allToDos"
                                    :key="todo.id"
                                    class="d-flex justify-content-between align-items-center"
                                    :class="isSubmitChecked(todo.id) ? 'bg-primary-50' : ''"
                                >
                                    <div>
                                        <span class="h5 mb-0">{{ todo.rctd.title }}</span>
                                        <span class="ml-2 text-uppercase font-size-70" :class="todo.rctd.required ? 'text-dark' : 'text-muted'">
                                            {{ todo.rctd.required ? 'Required' : 'Optional' }}
                                        </span>
                                    </div>
                                    <div>
                                        <div
                                            v-if="todo.draftReply"
                                        >  <!-- Show checkbox if there is a draft, but disable if not ready -->
                                            <div class="d-flex align-items-center">
                                                <div v-if="todo.draftReply.can_new_submit" class="d-flex align-items-center">
                                                    <div class=font-weight-bold>Submit Now?</div>
                                                    <b-checkbox 
                                                        :checked="isSubmitChecked(todo.id)" 
                                                        @change="handleSubmitChecked($event, todo)" 
                                                        switch 
                                                        inline
                                                        :disabled="(todo.draftReply.can_new_submit === false) || (!submitAllowedByBackend)"
                                                        class="draft-submit-checkbox ml-2 mr-0 text-muted text-uppercase font-size-80"
                                                    >
                                                        {{ isSubmitChecked(todo.id) ? 'Yes' : 'No' }}
                                                    </b-checkbox>
                                                </div>
                                                <div v-else class="d-flex align-items-center">
                                                    <div class="text-right">
                                                        <div class="text-uppercase font-size-70 font-weight-bold">Incomplete</div>
                                                        <div class="text-muted font-size-70">Unable to Submit</div>
                                                    </div>
                                                    <b-icon icon="x" variant="danger" class="p-1 rounded-circle bg-danger-100 ml-2" font-scale="2"></b-icon>
                                                </div>
                                            </div>
                                            <!-- <div v-if="todo.lastSubmittedReply" class="text-muted font-size-70">
                                                Previous version submitted on {{ todo.lastSubmittedReply.submittedOn }}
                                            </div> -->
                                        </div>
                                        <div v-else class="d-flex align-items-center">
                                            <div class="text-right">
                                                <div class="text-uppercase font-size-70 font-weight-bold" :class="todo.replyState === 'skipped' ? 'text-muted' : ''">{{ todo.replyStatusSubmitHeading }}</div>
                                                <div v-if="todo.replyStatusSubmitSubheading" class="text-muted font-size-70">{{ todo.replyStatusSubmitSubheading }}</div>
                                            </div>
                                            <b-icon v-if="todo.replyStatusSubmitIcon" :icon="todo.replyStatusSubmitIcon" :variant="todo.replyStatusSubmitVariant" class="p-1 rounded-circle ml-2" :class="'bg-' + todo.replyStatusSubmitVariant + '-100'" font-scale="2"></b-icon>
                                        </div>
                                        <!-- <div v-else class="text-muted text-uppercase font-size-80">Not Completed</div> -->
                                    </div>
                                </b-list-group-item>
                            </b-list-group>
                        </div>
                        
                        <div 
                            class="mt-4"
                        >
                            <b-form-group
                                id="portal-rfxresponse-submit-comment-fieldset"
                                label="Additional Comments?"
                                label-for="portal-rfxresponse-submit-comment"
                                label-class="font-weight-bold"
                            >
                                <b-form-textarea
                                    id="portal-rfxresponse-submit-comment"
                                    v-model="comment"
                                    placeholder="Optional comments to submit with response..."
                                    rows="4"
                                    max-rows="8"
                                    trim
                                ></b-form-textarea>
                            </b-form-group>
                            <div 
                                v-if="is_flagged_for_vendor"
                                class="border rounded py-2 px-3 bg-gray-100"
                            >
                                <b-form-checkbox
                                    id="portal-rfxresponse-submit-clear-isflagged"
                                    name="clear_is_flagged"
                                    switch
                                    :disabled="!canSubmit"
                                    v-model="clear_is_flagged"
                                >
                                    <div class="font-weight-bold">Mark follow-up request as resolved when you submit this?</div>
                                    <div class="small">This will remove the "flagged for follow-up" set by the buyer.</div>
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>

                    <busy-spinner
                        v-if="displayMode === 'submitting'"
                        key="submitting"
                        inner-class="my-5"
                        text="Submitting your response..."
                    ></busy-spinner>

                    <div
                        v-if="displayMode === 'submitSuccess'"
                        key="submitSuccess"
                        class="my-5 d-flex flex-column align-items-center"
                    >
                        <div class="d-flex justify-content-center align-items-center">
                            <div class="mr-3">
                                <b-icon
                                    icon="check-circle-fill"
                                    variant="success"
                                    font-scale="2"
                                    class=""
                                ></b-icon>
                            </div>
                            <div>
                                <h3>Success</h3>
                                <h5 class="text-muted mb-0">{{ submitMessage }}</h5> 
                            </div>
                        </div>

                        <div v-if="submissionExcelDownloadUrl" class="mt-5 mb-4 text-center">
                            <b-button :href="submissionExcelDownloadUrl" size="lg" variant="subtle-secondary" class="d-flex gap-4 align-items-center justify-content-between">
                                <div class="">
                                    Click here to download a copy<br>of your submissions as an Excel file
                                </div>
                                <span class="fiv-sqo fiv-icon-xlsx font-size-200"></span>
                            </b-button>
                        </div>
                        
                        <div class="my-4">
                            <p class="lead">
                                What's next?
                            </p>
                            <ul class="list-flush list-margin-2">
                                <li>We will review your response as soon as possible.</li>
                                <li>If we have any questions, we will send you an email asking for clarifications, more information, or providing other feedback.</li>
                                <li>The emails from us may come from the Supplios system.  
                                    This helps us manage things efficiently and provide better feedback for our suppliers.
                                </li>
                                <li>If you have any questions or need to provide additional or updated information, you can go to your 
                                    <b-link href="/">Dashboard</b-link>
                                    and send us a message or update us directly from there.</li>
                            </ul>
                            <div class="text-center mt-5">
                                <b-button
                                    href="/"
                                    variant="primary"
                                    size="lg"
                                >
                                    Go To Dashboard
                                </b-button>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="displayMode === 'submitFail'"
                        key="submitFail"
                        class="my-5 d-flex flex-column align-items-center"
                    >
                        <b-icon
                            icon="x-circle-fill"
                            variant="danger"
                            font-scale="2"
                            class="mb-3"
                        ></b-icon>
                        <h3>Submission Failed</h3>
                        <h5 class="text-muted mb-0">{{ submitMessage }}</h5> 
                    </div>

                </transition>
            </div>

            <transition name="fade-fast">
                <div 
                    v-if="!submitComplete"
                    class="text-center"
                >
                    <b-button
                        :disabled="!canSubmit || submitting"
                        variant="primary"
                        size="lg"
                        class="px-5"
                        @click="submitResponse"
                    >Submit Response</b-button>

                </div>
            </transition>

        </div>

    </div>
</template>

<script>
import { suppliosApi } from '../../js/api-service';
import { errorHandling, splUrlMapMixin, currentUserInfoMixin, tenantInfoMixin } from '../../js/custom-vue-mixins';
import { RfxCompanyToDoReplyStatus } from '../company_todos/rfx_company_todo_classes';
//import RfxResponseTransitions from '../RfxResponseTransitions';

export default {
    name: 'PortalRfxResponseSubmit',
    components: {
        //RfxResponseTransitions,
    },
    mixins: [
        errorHandling,
        splUrlMapMixin,
        currentUserInfoMixin,
        tenantInfoMixin,
    ],
    props: {
        responseId: {
            type: [String, Number],
            required: true,
        }
    },
    data: function() {
        return {
            submitting: false,  // loading indicator when we are handling submission
            checking: true,  // loading indicator for checking validity - start with TRUE
            checkComplete: false,  // set to TRUE after checking validity whether valid or not (and if you allow multiple validity checks, reset to false when starting a new check)
            submitAllowedByBackend: false,  // set from server-side via API, this is not 'is_valid', but rather 'there is nothting blocking a submit from backend, as long as you are submitting valid replies'
            checkInvalidMessages: [],  // list of strings explaining problems with creating new submission
            allToDos: [], // ALL the RfxCompanyToDoReplyStatus instances will be here
            replyMap: new Map(),  // Map or Object? with mapping of all replies this component knows about, object because we'll have duplicates based on how things come from api right now, keys are replyId, values are CompanyToDoReply instances 
            invalidToDos: [],  // put invalid things here - instances of JS class RfxCompanyToDoReplyStatus
            submitComplete: false,  // set to true after trying to submit (whether success or not)
            submitIsValid: false,  // set to true if submit was successful
            submitMessage: '',  // message to show after submit, from API
            submissionExcelDownloadUrl: '',  // returned after we submit
            comment: '',  // the submit comment - v-model from textarea
            is_flagged_for_vendor: false,  // will get this during checkValidity API call - then stash here
            clear_is_flagged: true,  // if is_flagged_for_vendor is true, we show this checkbox to allow 'clearing' it on submission - must send in POST data - we'll default to true since that's most logical
            todoSubmitMapping: {},  // Object that maps RfxCompanyToDoId: ReplyId that we want to submit (easier to make object reactive compared to Map)
            selectedRepliesValid: false,  // based on checkboxes of what user wants to submit, are all todos satisfied, either from new submit selections, or from lastSubmittedReply?
            replySubmitCount: null,  // we set this as we add/remove from todoSubmitMapping
            hasRepliesToSubmit: false,  // do you have anything to submit?
            replyValidMap: {},  // FOR TESTING
            //replyIdSubmitSet: new Set(),  // set of REPLY IDs to submit as new - just the IDs here, then we'll get from replyMap before sending back
        }
    },
    computed: {
        displayMode: function() {
            // use this to control state of what should be shown 
            // options are (strings): 'checking', 'submitting', 'checkedValid', 'checkedInvalid', 'submitSuccess', 'submitFail'
            if (this.checking) return 'checking';
            if (this.submitting) return 'submitting';
            if (this.checkComplete && !this.submitComplete) {
                //return 'checked';
                if (this.submitAllowedByBackend) return 'checkedValid';
                return 'checkedInvalid';
            }
            if (this.submitComplete) {
                if (this.submitIsValid) return 'submitSuccess';
                return 'submitFail';
            }
            return 'invalidState';  // should never get here...
        },
        canSubmit: function() {
            // combine all the validation related things into one - controls overall ability to submit
            return this.submitAllowedByBackend && this.selectedRepliesValid && this.hasRepliesToSubmit;
        },
    },
    mounted: function() {
        this.checkValidity();
    },
    methods: {
        // use this.apiErrorHandler(error) from mixin
        buildReplyMap: function(rctdStatusList) {
            // working with class instances here
            let replyMap = new Map();
            const addRepliesToMap = function(replyArray) { 
                replyArray.forEach(replyObj => {
                    replyMap.set(replyObj.id, replyObj);
                });
            };
            rctdStatusList.forEach(todo => {
                if (todo.allReplies.length) {
                    addRepliesToMap(todo.allReplies);
                }
            });
            return replyMap;
        },
        makeToDoInstances: function(rctdStatusList) {
            // build list of RfxCompanyToDoReplyStatus instances, return it
            if (!rctdStatusList.length) return [];
            let todoList = rctdStatusList.map(todo => new RfxCompanyToDoReplyStatus(todo));
            return todoList;
        },
        setInitialSubmitMapping: function(todoArray) {
            // pass in an array of RfxCompanyToDoReplyStatus instances, populate this.todoSubmitMapping with the initial values
            // include keys for ALL RfxCompanyToDos, but if not submitting new reply, just use 'null' as value
            let todoReplyObj = {};  // create new Object, then set it on this.todoSubmitMapping to make sure its reactive
            //let replyIdSubmitSet = new Set();  // will set on this.replyIdSubmitSet... set of IDs of replies we want to newly submit
            todoArray.forEach(todo => {  // is there a draftReply?  and can it be submitted?
                let replyId = todo.draftReply?.can_new_submit ? todo.draftReply.id : null;
                todoReplyObj[todo.id] = replyId;  // will put this in this.todoSubmitMapping
                /* if (todo.draftReply?.can_new_submit) {
                    replyIdSubmitSet.add(todo.draftReply.id);  // or add directly to this.replyIdSubmitSet?
                } */
            });
            this.todoSubmitMapping = Object.assign({}, todoReplyObj);  // do it like this to make sure its reactive 
            //this.replyIdSubmitSet = replyIdSubmitSet;  // vue.set instead?  do you need it to be reactive?
            console.log('todoSubmitMapping');
            console.log(this.todoSubmitMapping);
            //console.log('replyIdSubmitSet');
            //console.log(this.replyIdSubmitSet);
            this.checkSelectedRepliesValid();
        },
        isSubmitChecked: function(todoId) {
            // return boolean - check this.todoSubmitMapping to see if we have a replyId to submit here... should we make sure replyId matches???? redo how you figure out which reply should be submitted instead?
            return !!this.todoSubmitMapping[todoId];
        },
        handleSubmitChecked: function(isChecked, todoObj) {
            // handler for @change on submit checkboxes -- set this.todoSubmitMapping values
            // replyId is the ID we want to submit (if isChecked === true)
            let todoId = todoObj.id;
            let replyId = todoObj.replyToSubmit.id;
            // let replyToSubmit = todoObj.replyToSubmit;
            console.log('isChecked, todoId, replyId');
            console.log(isChecked);
            console.log(todoId);
            console.log(replyId);
            let newReplyId = (isChecked && replyId) ? replyId : null;  // make sure we use null if not submitting this reply
            this.todoSubmitMapping[todoId] = newReplyId;  // we use this for checking replies are valid
            /* if (isChecked) {
                this.replyIdSubmitSet.add(replyId);
            } else {
                this.replyIdSubmitSet.delete(replyId);
            } */
            console.log('todoSubmitMapping');
            console.log(this.todoSubmitMapping);
            //console.log('replyIdSubmitSet');
            //console.log(this.replyIdSubmitSet);
            // now run through all todos and see if we still have valid replies for everything
            this.checkSelectedRepliesValid();
        },
        checkSelectedRepliesValid: function() {
            // call this to update this.selectedRepliesValid -- on initial load, and when updating checkbox selections
            this.selectedRepliesValid = this.allToDos.every(todo => {
                const selectedReplyId = this.todoSubmitMapping[todo.id];  // returns the replyId if submitting new reply, or null if not submitting new one
                const isAllowed = todo.allowSubmit(selectedReplyId);  // returns boolean
                if (!isAllowed) console.log(`Todo ${todo.rctd.title} is blocking submit`);
                return isAllowed;
            });
            // and make sure you have at least one thing to submit!
            let replyIdsToSubmit = Object.values(this.todoSubmitMapping).filter(replyId => !!replyId);
            this.replySubmitCount = replyIdsToSubmit.length; 
            this.hasRepliesToSubmit = this.replySubmitCount > 0;
        },
        checkValidity: function() {
            this.checking = true;
            return suppliosApi.rfxResponse.checkCanCreateSubmission(this.responseId)
                .then(response => {  // returns object with keys { not_blocked (boolean), error_messages ([string]), invalid_todos([todo objs]) }
                    console.log('got response from checkCanCreateSubmission');
                    console.log(response.data);
                    this.submitAllowedByBackend = response.data.not_blocked;  // if True, this doesn't mean we're totally good -- just means we are not blocked
                    this.checkInvalidMessages = response.data.error_messages;
                    let allToDos = this.makeToDoInstances(response.data.all_todos);
                    //this.replyMap = this.buildReplyMap(response.data.all_todos);  // do thsi BEFORE calling setInitialSubmitMapping?
                    this.replyMap = this.buildReplyMap(allToDos);  // do thsi BEFORE calling setInitialSubmitMapping?
                    this.setInitialSubmitMapping(allToDos);  // do this BEFORE setting this.allToDos
                    this.allToDos = allToDos;
                    this.is_flagged_for_vendor = response.data.is_flagged_for_vendor;
                    this.invalidToDos = this.makeToDoInstances(response.data.invalid_todos);
                    this.checkComplete = true;  // make sure this.submitAllowedByBackend was set first, and only set this on succcessful api call, not in catch?
                    return true;  // true just means 'we checked successfully, without errors'
                })
                .catch(error => {
                    this.apiErrorHandler(error);
                    return false;
                })
                .then(success => {
                    this.checking = false;
                    return success;
                });
        },
        submitResponse: function() {
            // handle the submit
            this.submitting = true;
            // get the reply objects to submit
            let replies_to_submit = [];
            let replyIdsToSubmit = Object.values(this.todoSubmitMapping).filter(replyId => !!replyId);
            replyIdsToSubmit.forEach(repId => {
                replies_to_submit.push(this.replyMap.get(repId));  // Map.get() returns undefined if not found 
            });
            // Must make a reply_submit_map that ONLY has key/values for DRAFTS -- only ones we want to specifically submit or not submit
            // can't just loop over replies to submit, because then you'll miss drafts that you purposely DO NOT want to submit reply for yet
            let draftSubmitMap = {};
            Object.entries(this.todoSubmitMapping).forEach(([todoId, replyId]) => {
                if (this.allToDos.filter(rctd => !!rctd.draftReply).map(rctd => rctd.id).includes(todoId)) {
                    draftSubmitMap[todoId] = replyId;  // replyId might be None, but that's OK
                }
            });
            console.log('draftSubmitMap');
            console.log(draftSubmitMap);
            let postData = {
                submit_note: this.comment,
                reply_submit_map: this.todoSubmitMapping,  // old
                replies_to_submit: replies_to_submit,  // old
                draft_submit_map: draftSubmitMap,
                clear_is_flagged: this.clear_is_flagged,  // Boolean, if response has is_flagged_for_vendor, setting this to true will clear it on submit
            };
            console.log(postData);
            return suppliosApi.rfxResponse.createNewSubmission(this.responseId, postData)
                .then(response => {
                    console.log('Successful submit, response below');
                    console.log(response);
                    // check for keys 'success' (boolean) and 'message' (string) in response data - we return those if all was OK
                    this.submitIsValid = response.data.success || false;  // if 'success' key was not there, will be undefined
                    this.submitMessage = response.data.message ? response.data.message : 'There was a problem with your submission.  Please contact support.';
                    this.submissionExcelDownloadUrl = response.data?.excel_download_url ?? '';
                    // EMIT SOMETHING TO PARENT 
                    this.$emit('submitted');  // if parent does anything here, we won't show the submit success message!
                    return true;
                })
                .catch(error => {
                    this.apiErrorHandler(error);
                    return false;
                })
                .then(success => {
                    // putting submitComplete down here, because even if there is api error, we'll still say its complete and show some error
                    this.submitComplete = true;  // make sure to set this.submitIsValid first, and set this before this.submitting = false;
                    this.submitting = false;
                    return success;
                });
        },
    }
}
</script>

<style lang="scss">

.draft-submit-checkbox {
    label.custom-control-label {
        min-width: 28px;
    }
}

</style>